import { NODE_ENV } from "../../config";
import { logger } from "../../helper/logger";

export const devAssert = (error: unknown, msg: string) => {
    logger.error(msg, error);
    reportError(error);
    if (NODE_ENV !== "production") {
        throw error;
    }
}